module.exports = __webpack_public_path__ + "img/syyy-selected.2e6ad31f.png";